<div class="container" [ngClass]="customSweepBuckMenuClasses">
    <div class="backdrop" (click)="closeMenu()" id="sweep-backdrop" [ngStyle]="{ 'top': getTopPosition() }"></div>
    <div class="menu" id="menu">
        <div class="inner-menu" (click)="goToAnotherPage('shop-home')">
            <img src="../../../../assets/img/sweep/card_pay.webp" alt="Get More"/>
            <div>GET MORE</div>
        </div>
        <div class="divider-line"></div>
        <div class="inner-menu" (click)="goToAnotherPage('lobby/cashier/redeem')">
            <img class="redeem-png" src="../../../../assets/img/sweep/redeem.webp" alt="Get More"/>
            <div>REDEEM</div>
        </div>
    </div>
</div>
